import React, { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useStyles } from './SectorIndexPage.style'
import { useParams } from 'react-router-dom'
import {
  Button,
  Dialog,
  DialogActions,
  DialogTitle,
  Typography,
  Tooltip,
  Box
} from '@material-ui/core'
import {
  Add,
  Delete,
  Edit,
  EventSeat,
  ArrowBack,
  FileCopy
} from '@material-ui/icons'
import {
  loadLayout,
  loadSectorsPaged,
  deleteSector,
  reset
} from '~/state/modules/planimetry'
import {
  TableGrid,
  createColumn,
  createCustomColumn,
  TableGridOrder,
  DeleteDialog,
  PaperContainer
} from '~/views/shared'
import history from '~/config/history'
import { ROUTES } from '~/views/routes'
import { showSnackbarError } from 'views/utils/snackbar'
import { cleanHexColor } from 'views/utils/functions'
import { ImageDialog } from './ImageDialog'

const makeColumns = (
  setSelectedSector,
  setShowDeleteDialog,
  locationId,
  layoutId,
  classes
) => {
  return [
    createColumn('Name', 'Nombre', 'left', (value, row) => (
      <div className={classes.containerName}>
        {!!cleanHexColor(row?.Color) && (
          <div
            className={classes.colorTicket}
            style={{ backgroundColor: row.Color }}
          />
        )}
        <Typography variant='body2'>{row.Name}</Typography>
      </div>
    )),
    createCustomColumn(
      (c) => (
        <Typography variant='body2'>
          {c?.Row && c?.Column ? c.Row * c.Column : '0'}
        </Typography>
      ),
      'Cant. Max de Asientos'
    ),
    createColumn('Row', 'Filas'),
    createColumn('Column', 'Columnas'),
    createCustomColumn(
      (c) => (
        <Button
          onClick={() => {
            history.push(
              ROUTES.ADMIN.LOCATIONS.PLANIMETRY.SECTORS.UPDATE.replace(
                ':locationId',
                locationId
              )
                .replace(':layoutId', layoutId)
                .replace(':sectorId', c.Id)
            )
          }}>
          <Edit />
        </Button>
      ),
      'Editar'
    ),
    createCustomColumn(
      (c) => (
        <Button
          onClick={() => {
            history.push(
              ROUTES.ADMIN.LOCATIONS.PLANIMETRY.SECTORS.SEATS.replace(
                ':locationId',
                locationId
              )
                .replace(':layoutId', layoutId)
                .replace(':sectorId', c.Id)
            )
          }}>
          <EventSeat />
        </Button>
      ),
      'Editar Dist. de Asientos'
    ),
    createCustomColumn(
      (c) => (
        <Button
          onClick={() => {
            history.push(
              ROUTES.ADMIN.LOCATIONS.PLANIMETRY.SECTORS.CLONE.replace(
                ':locationId',
                locationId
              )
                .replace(':layoutId', layoutId)
                .replace(':sectorId', c.Id)
            )
          }}>
          <FileCopy />
        </Button>
      ),
      'Clonar'
    ),
    createCustomColumn(
      (c) => (
        <Button
          onClick={() => {
            setSelectedSector(c)
            setShowDeleteDialog(true)
          }}>
          <Delete />
        </Button>
      ),
      'Eliminar'
    )
  ]
}

export const SectorIndexPage = () => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const { locationId, layoutId } = useParams()
  const {
    pagedSectors,
    pendingSectors,
    reqParams,
    pendingDeleteLayout,
    layout
  } = useSelector((state) => state.planimetry)
  const [selectedSector, setSelectedSector] = useState(null)
  const [showDeleteDialog, setShowDeleteDialog] = useState(false)

  const [open, setOpen] = useState(false)
  const [openDialog, setOpenDialog] = useState(false)

  const handleClose = async () => {
    setOpen(false)
    await dispatch(reset())
    dispatch(
      loadSectorsPaged(layoutId, {
        searchParams: '',
        pageNumber: 0,
        orderBy: 'Name',
        order: TableGridOrder.ASC
      })
    )
    dispatch(loadLayout(layoutId))
  }

  const handleDelete = async () => {
    try {
      await dispatch(deleteSector(selectedSector?.Id))
      setShowDeleteDialog(false)
      setOpen(true)
    } catch (error) {
      showSnackbarError(error)
    }
  }

  useEffect(() => {
    async function fetchData() {
      await dispatch(loadLayout(layoutId))
    }

    fetchData().then()
    // eslint-disable-next-line
  }, [])

  const handleBack = () => {
    history.push(
      ROUTES.ADMIN.LOCATIONS.PLANIMETRY.INDEX.replace(':locationId', locationId)
    )
  }

  return (
    <>
      <PaperContainer
        title={
          <div className={classes.titleContainer}>
            <Typography className={classes.title}>
              {`Listado de Sectores de "${layout?.Name ?? '-'}"`}
            </Typography>
            <div className={classes.containerButtons}>
              {layout?.ImageCdnUrl && (
                <Tooltip title='Ver imagen de la planimetría'>
                  <Box
                    sx={{ cursor: 'pointer' }}
                    onClick={() => {
                      setOpenDialog(true)
                    }}>
                    <img
                      src={layout.ImageCdnUrl}
                      alt='plany'
                      width={90}
                      height={70}
                      className={classes.imageLayout}
                    />
                  </Box>
                </Tooltip>
              )}
              <Button
                onClick={handleBack}
                color='primary'
                startIcon={<ArrowBack />}>
                Volver a Planimetrias
              </Button>
            </div>
          </div>
        }>
        <TableGrid
          title={''}
          rowClasses={(x) => x?.IsEnabled && `${classes.conditionalRow}`}
          columns={makeColumns(
            setSelectedSector,
            setShowDeleteDialog,
            locationId,
            layoutId,
            classes
          )}
          loadItemsPage={(x) => {
            dispatch(
              loadSectorsPaged(layoutId, {
                searchParams: '',
                pageNumber: 0,
                orderBy: 'Name',
                order: x.order
              })
            )
          }}
          isLoading={pendingSectors}
          pagedList={pagedSectors}
          keyName='Id'
          order={reqParams?.order || TableGridOrder.ASC}
          orderBy={reqParams?.orderBy || 'Name'}
          useNewFormat
          hideFooter
        />
        <div className={classes.createButtonContainer}>
          <Button
            onClick={() =>
              history.push(
                ROUTES.ADMIN.LOCATIONS.PLANIMETRY.SECTORS.CREATE.replace(
                  ':locationId',
                  locationId
                ).replace(':layoutId', layoutId)
              )
            }
            color='primary'
            variant='contained'
            startIcon={<Add />}>
            Crear
          </Button>
        </div>
      </PaperContainer>
      <ImageDialog
        open={openDialog}
        onClose={() => setOpenDialog(false)}
        layoutName={layout?.Name}
        imageLayout={layout?.ImageCdnUrl}
      />
      <DeleteDialog
        open={showDeleteDialog}
        loading={pendingDeleteLayout}
        handleDelete={handleDelete}
        onCancel={() => setShowDeleteDialog(false)}
        title={'Eliminar Sector'}
        message={'Está por eliminar el sector'}
        entityIdentifier={selectedSector?.Name}
      />
      <Dialog open={open}>
        <DialogTitle>Sector eliminado</DialogTitle>
        <DialogActions>
          <Button onClick={handleClose} color='primary' autoFocus>
            OK
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}

export default SectorIndexPage
